import { createFileRoute } from "@tanstack/react-router";
import { JobTypeRulesSection } from "./fullRules";

export const Route = createFileRoute(
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/configuration/jobTypes/$jobTypeId/rules",
)({
	component: OrgJobTypeRulesTab,
});

function OrgJobTypeRulesTab() {
	return (
		<div className="px-5 pb-5">
			<JobTypeRulesSection stayOnRoute />
		</div>
	);
}
